export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit information about the collector"])}
}